<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" (click)="open(back)"><img src="assets/images/admin/backarrow.png" /> Back to course Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>

<div class="centerWrap mt-4 pt-2">    
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
        <h2>Assign Courses</h2>
        <p>Select 1 or more courses from the list to assign to this user. </p>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterWrap">
            <div class="searchWrap mr-0">
                <input type="text" placeholder="Search Users" (keyup)="search($event)">
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterSelect">
            <span>Filter by Organisation:</span>
            <div class="selectCustom">
                <select (change)="selectChangeHandler($event)">
                    <option value='0'>All</option>
                    <option *ngFor="let organisation of organisationData" [value]="organisation.organisation_id">{{organisation.org_name}}</option>
                    <!-- <option value='0'>All</option>
                    <option value='1'>northern railway</option>
                    <option value='2'>eastern railway</option>
                    <option value='5'>southern railway</option>
                    <option value='6'>north-west railway</option>
                    <option value='7'>north-west railway</option> -->
                </select>
            </div>
        </div>
    </div>
        </div>
    </div>


    <div class="tableWrap">
        <table  matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th>
                    <!-- <div class="customCheck">
                        <mat-checkbox></mat-checkbox>
                    </div> -->
                    </th>
                    <th><div  mat-sort-header="first_name"><b></b> Users</div></th>
                    <th>Email ID</th>
                    <th>Phone Number</th>
                    <th mat-sort-header="organisation_name">Organisation</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let values of userData;let i = index">
                    <td>
                        <div class="customCheck">
                            <mat-checkbox (change)="onChangeDemo($event,values.user_id,i)"></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>{{values.first_name}}</span>
                            <b>Created on {{values.created_dttm}}</b>
                        </div>
                    </td>
                    <td>
                        {{values.email}}
                    </td>
                    <td>{{values.phone}}</td>
                    <td>{{values.organisation_name}}</td>
                </tr>
             
             </tbody>
        </table>

        <div class="text-center">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(cancel)">Cancel</a>
            <a href="javascript:void(0);" (click)="open(content)" class="btn btn-primary btn-sm" [ngClass]="(selectUserId.length < 1 ) ? 'btn btn-primary btn-sm  disable ' :
            'btn btn-primary btn-sm ' ">Assign Users to the Courses</a>
        </div>
    </div>
</div>
<ng-template #cancel let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Cancel Assign User</h6>
            <p class="size18">Are you sure you want to skip the course?</p>
            <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">No, cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="cancelCourse()">Yes, cancel</a>
        </div>
    </div>
</ng-template>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Assign  Users</h6>
            <p class="size18">Are you sure you want to publish the course  assign it is the users selected?</p>
            <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">No, cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" 
                (click)="publish()">Yes, Assign</a>
        </div>
    </div>
</ng-template>
<ng-template #back let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Back to course module</h6>
                <p class="size18">Are you sure you would like to back to course module?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);"  class="btn btn-primary btn-sm" (click)="cancelbkModule()"> Yes,Back</a>
            </div>
        </div>
    </div>
</ng-template>